// extracted by mini-css-extract-plugin
module.exports = {"MenuGroup--max-height":"oz_a"};